import {Button, Modal} from "react-bootstrap";

function ContinueOfflinePopupProspectFailed(props) {
    const handleClose = () => {
        props.setParentContinueOfflinePopupShow(false);
    };


    return (
        <>
            <Modal
                show={props.parentContinueOfflinePopupShow}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="mediumTextStyles"><span style={{color: 'red'}}>Sorry</span> </Modal.Title>
                </Modal.Header>

                <Modal.Body className="regularTextStyles">
                    <p>
                        While we can provide insurance for most cars, we can’t insure this vehicle.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ContinueOfflinePopupProspectFailed;